import { UserRole } from 'src/common/commonTypes';
import { useAppSelector } from 'src/store/store';
import { selectUserRole } from 'src/userInfo/slice';

type Props = IncludeRoleProps | ExceptRoleProps;

function VisibilityFilter(props: Props) {
    const userRole = useAppSelector(selectUserRole);
    const { extraFilter, children } = props;

    if (userRole) {
        const filterPassed =
            extraFilter === undefined || (typeof extraFilter === 'function' ? extraFilter() : extraFilter);
        if (filterPassed) {
            if (isIncludeRoleProps(props)) {
                const role = props.role;
                if (Array.isArray(role)) {
                    if (role.includes(userRole)) {
                        return children;
                    }
                } else {
                    if (userRole === role) {
                        return children;
                    }
                }
            } else if (isExceptRoleProps(props)) {
                const excludedRole = props.exceptRole;
                if (Array.isArray(excludedRole)) {
                    if (!excludedRole.includes(userRole)) {
                        return children;
                    }
                } else {
                    if (userRole !== excludedRole) {
                        return children;
                    }
                }
            }
        }
    }

    return null;
}

type CommonProps = {
    children: React.ReactElement;
    extraFilter?: boolean | (() => boolean);
};

type IncludeRoleProps = CommonProps & {
    role: UserRole | UserRole[];
};

type ExceptRoleProps = CommonProps & {
    exceptRole: UserRole | UserRole[];
};

function isIncludeRoleProps(props: Props): props is IncludeRoleProps {
    return 'role' in props;
}

function isExceptRoleProps(props: Props): props is ExceptRoleProps {
    return 'exceptRole' in props;
}

export default VisibilityFilter;
